import { graphql, useStaticQuery } from 'gatsby';

import { useFlatten } from './use-flatten';
import { getProperty } from 'utils';

export const useStaticHours = () => {
	const results = useStaticQuery(query) || {};
	const key = 'squidex.findHoursSingleton';

	return useFlatten(getProperty(results, key) || {});
};

const query = graphql`
	query useHoursQuery {
		squidex {
			findHoursSingleton {
				id
				data {
					items {
						de {
							label
							value
						}
					}
				}
			}
		}
	}
`;
